
import {
  defineComponent, ref, watch,
} from 'vue';

interface VideoElement extends HTMLVideoElement {
  pause(): void;
}

export default defineComponent({
  inheritAttrs: false,
  props: {
    url: { type: String, required: true },
    pauseVideo: { type: Boolean, required: true },
  },
  emits: ['loadedmetadata', 'ifVideoPaused'],
  setup(props, { emit }) {
    const videoElement = ref<VideoElement | null>(null);
    function logData(e) {
      // console.log(e);
    }

    watch(
      () => props.pauseVideo,
      (newValue) => {
        if (newValue && videoElement.value) {
          videoElement.value.pause();
          emit('ifVideoPaused');
        }
      },
    );

    return {
      logData,
      videoElement,
    };
  },
});
